import React from "react";
import { t } from "ttag";

import format from "../../../utils/format";
import { Dinero } from "../../../utils/money";

import styles from "./common.module.scss";

const SalesTax = (props: { totalTax: Dinero | null }): React.ReactNode => {
    if (props.totalTax === null) {
        return (
            <>
                {/* TODO(i18n): "Uncalculated Tax" is potentially translatable but needs product/UX decision: is this ever visible to end users or only in edge cases? If user-visible, consider keeping translated. If technical/admin-only, may be acceptable as-is. */}
                <span className="ada-screenreader-only">
                    {t`Uncalculated Tax`}
                </span>
                {format.money(props.totalTax)}
            </>
        );
    }
    return format.money(props.totalTax);
};

export const SalesTaxRow = (props: {
    totalTax: Dinero | null;
}): React.ReactNode => (
    <span className={styles.line}>
        <li>{t`Sales Tax`}</li>
        <li>
            <SalesTax {...props} />
        </li>
    </span>
);
